import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { __rest as i } from "../_virtual/_tslib.js";
import { jsx as e } from "react/jsx-runtime";
import { createElement as t } from "react";
import { calculateRem as r } from "@vds-core/utilities";
import { ColorTokens as o } from "@vds-tokens/color";
import { Fonts as n } from "@vds-core/typography";
import { TypographyTokens as a } from "@vds-tokens/typography";
import d from "styled-components";
var l = d.div.withConfig({
    displayName: "StyledHeader",
    componentId: "VDS__sc-rfou8v-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover,\n  &:active,\n  &:visited {\n    outline: none;\n  }\n"]))),
  m = d(function (e) {
    var r = e.primitive,
      o = i(e, ["primitive"]);
    return t(r, o);
  }).withConfig({
    displayName: "StyledHeaderText",
    componentId: "VDS__sc-rfou8v-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  padding: ", ";\n  margin: 0;\n  flex: 1;\n\n  @media (min-width: 767px) {\n    font-size: ", ";\n    line-height: ", ";\n  }\n"])), function (_ref) {
    var i = _ref.surface;
    return "dark" === i ? o.elements.primary.ondark.value : o.elements.primary.onlight.value;
  }, r(a.fontsize.title[24].value), r(a.lineheight.title[28].value), n.VerizonNHGeDS, function (_ref2) {
    var i = _ref2.padding;
    return i;
  }, r(a.fontsize.title[32].value), r(a.lineheight.title[36].value)),
  p = function p(i) {
    var t = i.children,
      r = i.primitive,
      o = i.padding,
      n = i.surface,
      a = i.id;
    return e(l, {
      "data-testid": "modal-header",
      children: e(m, {
        padding: o,
        id: a,
        primitive: r,
        surface: n,
        children: t
      })
    });
  };
p.defaultProps = {
  children: null,
  primitive: "h2",
  padding: "0px",
  surface: "light"
}, p.displayName = "ModalTitle";
export { p as default };